var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Transition',{attrs:{"name":"slide"}},[_c('div',[_c('v-overlay',{staticClass:"overlay-backdrop",attrs:{"model-value":true,"persistent":""}}),_vm._v(" "),_c('div',{staticClass:"full-screen rounded-t-xl"},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }